// extracted by mini-css-extract-plugin
module.exports = {"modalStyle":"_2QESw52PFjcB2OYvAaL68x","modalFooter":"_36yGCm0LBtEMV_-BT9FiSW"};